import { gql } from '@apollo/client';

export const GET_WORK_PROGRESS_BAG_MAWB_BAG_PARCEL_SUMMARIES = gql`
  # 大包进度页面：有提单号第三级展开（提单号下按大包号 + 日期汇总包裹）
  query GetWorkProgressBagMawbBagParcelSummaries($filter: WorkProgressBagMawbBagParcelSummaryFilterInput!) {
    getWorkProgressBagMawbBagParcelSummaries(filter: $filter) {
      bagNumber
      arrivalDate
      isInbound
      expectedParcelCountSum
      inboundParcelCountSum
      parcelDiffSum
      parcelDiffRate
      scanTime
    }
  }
`;

export interface WorkProgressBagMawbBagParcelSummaryRow {
  bagNumber: string;
  /** 该大包汇总行对应的入库/到港日（YYYY-MM-DD） */
  arrivalDate: string;
  isInbound: boolean;
  expectedParcelCountSum: number;
  inboundParcelCountSum: number;
  parcelDiffSum: number;
  parcelDiffRate: number;
  /** client_carton.scan_time（ISO-8601 UTC），与下钻 drawer 同源；未匹配到为 null */
  scanTime: string | null;
}

export interface GetWorkProgressBagMawbBagParcelSummariesResponse {
  getWorkProgressBagMawbBagParcelSummaries: WorkProgressBagMawbBagParcelSummaryRow[];
}

export interface WorkProgressBagMawbBagParcelSummaryFilterInput {
  hubId: number;
  arrivalDateStart: string;
  arrivalDateEnd: string;
  customerId: number;
  mawb: string;
  /** 与后端一致：true/false 时只查对应 is_inbound；不传则该提单下全部大包 */
  isInbound?: boolean | null;
  /** true：仅查询已入库大包口径 */
  inboundBagOnly?: boolean | null;
}

